export default __webpack_public_path__ + "static/media/page-cropped.450be474.jpg";